import React from 'react';
const ArsiIcon = (props: React.SVGProps<SVGSVGElement>) => (

    <svg
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M11.8362 14.2976C11.2077 15.3854 11.2077 16.726 11.8362 17.8138C13.0442 19.9044 15.7197 20.6206 17.812 19.4137C19.9043 18.2067 20.6212 15.5336 19.4132 13.443L15.8126 7.21191C15.7185 7.5086 15.591 7.79974 15.4288 8.08037L11.8362 14.2976Z"
            fill="currentColor" />
        <path d="M6.21124 3.70958C7.41924 1.61905 10.0947 0.902778 12.187 2.10975C14.2793 3.31671 14.9962 5.98986 13.7882 8.08039L8.16376 17.8139C6.95576 19.9044 4.28033 20.6207 2.18801 19.4137C0.0956906 18.2067 -0.62119 15.5336 0.58681 13.443L6.21124 3.70958Z"
            fill="currentColor" />

    </svg>

);

export default ArsiIcon;
